<script>
  import PagesTemplate from "./PagesTemplate.svelte";
  import Icon from "svelte-awesome";
  import { circleO } from "svelte-awesome/icons";
  import { jobs } from "../constants/content";
  import Job from "../components/content/Job.svelte";

  let isHovered = false;
</script>

<style>
  .timeline {
    padding: 4rem 2rem 4rem 4rem;
    position: relative;
    min-height: 100vh;
    height: 100%;
    max-width: 64rem;
    margin: 0 auto;
  }
  @media screen and (min-width: 900px) {
    .timeline {
      padding: 4rem;
    }
  }
  .timeline::before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50px;
    width: 4px;
    background: #ddd;
  }
  .entry {
    margin-bottom: 2rem;
  }
  .title {
    padding-left: 5rem;
    position: relative;
    margin-bottom: 2rem;
  }
  .body {
    padding-left: 5rem;
    position: relative;
  }
  .title::before {
    content: "";
    position: absolute;
    width: 16px;
    height: 16px;
    border: 4px solid var(--color-theme-3);
    background-color: var(--pageBackground);
    border-radius: 100%;
    top: 20%;
    left: 4px;
    z-index: 99;
  }
  .job-title {
    margin-bottom: 0;
    margin-top: 0;
    font-weight: 700;
  }
  .company {
    margin: 0;
  }
</style>

<PagesTemplate
  title="Employment"
  subtitle="A career that spans more than 25 years and includes healthcare,
  general web consulting, supply chain management, managed file transfer, and
  travel.">
  <div class="timeline">
    <!-- <div class="row is-center">
      <div class="col-12">
        {#each jobs as job (job.id)}
          <Job {job} />
        {/each}
      </div>
    </div> -->
    {#each jobs as job (job.id)}
      <div class="row entry">
        <div class="title col-12">
          <h4 class="job-title">{job.dates}</h4>
          <p class="job-title">{job.title}</p>
          <p class="company">{job.company} - {job.location}</p>
        </div>
        <div class="body col-12">
          {#each job.accomplishments as accomplishment}
            <p>{accomplishment}</p>
          {/each}
        </div>
        <hr />
      </div>
    {/each}
  </div>
</PagesTemplate>
